'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    USER_SETTINGS_CHANGED: 'userSettingsChanged.SETTINGS',
    DYNAMIC_PRICES_UPDATED: 'dynamicPricesUpdated.PRICES',
    RESIZE: 'resize',
    SWITCH_BREAKPOINTS: 'rpBreakpointsSwitch',
    MAKE_SELECTION: 'RC.makeSelection',
    BOOKMAKER_CHANGED: 'bookieChanged.BOOKMAKER',
    INFO_TOPIC_UPDATED: 'infoTopicUpdate.PRICES',
    HORSES_LIST_CHANGED: 'horsesListChanged',
    // TODO: RC - Race card related prefix (JIRA: PC-4557)
    PRICES_NEED_SORTING: 'RC.priceUpdatedToSort'
};


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/lib/js/constants/EVENTS.js
// module id = 1024
// module chunks = 0